import type { RequestConfig } from '@umijs/max';

export const errorConfig: RequestConfig = {
  baseURL: "https://api-v1.aydentify.com",
  // baseURL: "https://staging-api.tryscoutnow.com",
  withCredentials: true,
};
